import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

import { defaultAxiosConfig, getTraceId } from '@zep/apis';

import { ApiCommonResponse } from '../types/GlobalTypes';

interface AxiosCustomInstance extends AxiosInstance {
  get<T = Record<string, any>, R = ApiCommonResponse<T>>(
    url: string,
    config?: AxiosRequestConfig,
  ): Promise<R>;
  delete<T = Record<string, any>, R = ApiCommonResponse<T>>(
    url: string,
    config?: AxiosRequestConfig,
  ): Promise<R>;
  head<T = Record<string, any>, R = ApiCommonResponse<T>>(
    url: string,
    config?: AxiosRequestConfig,
  ): Promise<R>;
  options<T = Record<string, any>, R = ApiCommonResponse<T>>(
    url: string,
    config?: AxiosRequestConfig,
  ): Promise<R>;
  post<T = Record<string, any>, R = ApiCommonResponse<T>>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig,
  ): Promise<R>;
  put<T = Record<string, any>, R = ApiCommonResponse<T>>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig,
  ): Promise<R>;
  patch<T = Record<string, any>, R = ApiCommonResponse<T>>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig,
  ): Promise<R>;
}

export const createApiClient = (axiosConfig?: AxiosRequestConfig) => {
  const client = axios.create(axiosConfig);
  client.interceptors.response.use(
    (response: AxiosResponse) => {
      if (response.data.status !== undefined && response.data.status < 0) {
        throw response.data;
      }
      return response.data;
    },
    error => {
      console.error(error);
      throw error;
    },
  );

  client.interceptors.request.use(config => {
    config.headers['X-ZEP-Trace-Id'] = getTraceId();
    return config;
  });

  return client;
};

export const SERVER_API: AxiosCustomInstance = createApiClient({
  ...defaultAxiosConfig,
  baseURL: `${process.env.NEXT_PUBLIC_BASE_URL}/api`,
  timeout: 5000,
});
